import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Telefoonnummer',
      placeholder: 'Voer telefoonnummer in',
    },
    email: {
      label: 'E-mailadres',
      placeholder: 'Voer e-mailadres in',
    },
  },
  channel_chooser: {
    title: 'Stuur code via',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratis, snelste bezorging',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Standaard sms-bericht',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'E-mail',
      subtitle: 'Code direct in je inbox',
    },
  },
  otp: {
    title: 'Voer verificatiecode in',
    send_code: 'Stuur code',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Verzonden via <strong>WhatsApp</strong> naar <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Verzonden via <strong>SMS</strong> naar <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Verzonden via <strong>e-mail</strong> naar <strong>{{phone}}</strong>',
    },
    sent_to: 'Verzonden naar',
    resend: {
      title: 'Code niet ontvangen?',
      countdown: 'Opnieuw versturen over',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Code niet ontvangen via e-mail?',
          button: 'Opnieuw verzenden via e-mail',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Code niet ontvangen?',
          button: 'Opnieuw versturen via SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Code niet ontvangen?',
          button: 'Opnieuw versturen via WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Stuur in plaats daarvan via SMS',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Stuur in plaats daarvan via WhatsApp',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'Er is een bericht met een verificatiecode naar je telefoon gestuurd. Voer de code in om verder te gaan.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Voer de code in die naar dit adres is gestuurd: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'Er is een WhatsApp-bericht met een verificatiecode naar je telefoon gestuurd. Voer de code in om verder te gaan.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Tip: Controleer je inbox en je spammap.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Let op — de code wordt verzonden door <strong>{{sender}}</strong>, onze technologiepartner.',
    business_account: 'Zakelijk account',
    message: '<strong>123456</strong> is je verificatiecode. Deel deze code niet voor je eigen veiligheid.',
  },
  error_messages: {
    frequent_requests:
      'Controleer je berichten. We hebben de code al naar het opgegeven nummer gestuurd. Zo niet, controleer dan het telefoonnummer of probeer het over 10 minuten opnieuw.',
    frequent_requests_email:
      'Controleer je inbox en je spamfolder. We hebben de code al naar dat adres gestuurd. Als deze niet is aangekomen, probeer het over 10 minuten opnieuw.',
    invalid_number: 'Ongeldig nummer. Probeer het opnieuw.',
    invalid_email: 'We konden de code niet naar dat e-mailadres verzenden. Controleer het en probeer het opnieuw.',
    email_not_on_file:
      'Dit telefoonnummer heeft al een account zonder e-mailadres. Neem contact op met {{support_email}} om er een toe te voegen — tot die tijd kunnen we geen codes per e-mail sturen voor dit nummer.',
    turnstile_required: 'Voltooi de verificatie voordat je een nieuwe code aanvraagt.',
    generic_error: 'Oeps, er is iets misgegaan. Vernieuw de pagina en probeer het opnieuw.',
    change_phone_number_unsuccessful: 'Wijzigen van telefoonnummer mislukt. Probeer het opnieuw.',
  },
  toasts: {
    code_sent: 'Code verzonden',
  },
};
